module.exports = __webpack_public_path__ + "step1_M2F_nakagawa_bridal.454ce2b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1_M2F_nakagawa_bridal.jpg
// module id = /rGg
// module chunks = 0